import Account from '../../services/account'
import * as types from '../mutationTypes'

let state =
{
  email: null,
  error: null,
  success: null
}

const getters = {
  error (state) {
    return state.error
  },

  success (state) {
    return state.success
  }
}

const actions = {
  async sendForgotPassword ({ commit, dispatch }, email) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      if (email != null) {
        let res = await Account.sendForgotPassword(email)
        if (res.status === 200) {
          commit(types.REQUEST_FORGOT_PASSWORD_EMAIL, res)
        }
      } else {
        commit(types.REQUEST_FORGOT_PASSWORD_ERROR, 'Please enter an email')
      }
    } catch (err) {
      commit(types.REQUEST_FORGOT_PASSWORD_ERROR, `Error sending email ${err.Message}`)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async resetPassword ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      if (data.password === data.confirm) {
        var passwordForm = { password: data.password, email: data.email, token: data.token }
        let res = await Account.resetPassword(passwordForm)
        if (res.status === 200) {
          commit(types.REQUEST_RESET_PASSWORD_SUCCESS, res.data)
        }
      } else {
        commit(types.REQUEST_RESET_PASSWORD_ERROR, "Passwords Don't Match")
      }
    } catch (err) {
      commit(types.REQUEST_RESET_PASSWORD_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async resetPasswordAdmin ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      if (data.password === data.confirm) {
        var passwordForm = { password: data.password, email: data.email, token: null }
        let res = await Account.resetPasswordAdmin(passwordForm)
        if (res.status === 200) {
          commit(types.REQUEST_RESET_PASSWORD_SUCCESS, res.data)
        }
      } else {
        commit(types.REQUEST_RESET_PASSWORD_ERROR, "Passwords Don't Match")
      }
    } catch (err) {
      commit(types.REQUEST_RESET_PASSWORD_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  clearAccount ({ commit }) {
    commit(types.CLEAR_ACCOUNT)
  }
}

const mutations = {
  [types.REQUEST_FORGOT_PASSWORD_EMAIL] (state, res) {
    state.success = res.data
    state.error = null
    state.email = res.config.data
  },

  [types.REQUEST_FORGOT_PASSWORD_ERROR] (state, message) {
    state.success = null
    state.error = message
    state.email = null
  },

  [types.REQUEST_RESET_PASSWORD_ERROR] (state, message) {
    state.error = message
    state.success = null
  },

  [types.REQUEST_RESET_PASSWORD_SUCCESS] (state, res) {
    state.error = null
    state.success = res
  },

  [types.CLEAR_ACCOUNT] (state) {
    state.error = null
    state.success = null
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
